






































import { defineComponent, PropType } from '@vue/composition-api';
import * as Common from "../commons/common"
import { QuestionnaireGroup } from "../modules/Questionnaire"

export default defineComponent({
  props: {
    questionnaire_group: {
      type: Object as PropType<QuestionnaireGroup | null>,
      required: true
    },
    submitButtonText: {
      type: String as PropType<string>,
      required: false,
      default: "登録"
    },
  },
  setup(props, context){

    const entry = async () => {
      for(const questionnaire of props.questionnaire_group.questionnaires) {
        if(questionnaire.is_required){
          if(questionnaire.answer_type === Common.QuestionnaireAnswerTypeEnum.Rating && questionnaire.point == null){
            await Common.customAlert(context.root.$bvModal, context.root.$store, `必須項目にご回答ください。`);
            return;
          }
          if(questionnaire.answer_type === Common.QuestionnaireAnswerTypeEnum.FreeText && !questionnaire.answer_text){
            await Common.customAlert(context.root.$bvModal, context.root.$store, `必須項目にご回答ください。`);
            return;
          }
        }
      }
      context.emit("entry-questionnaire-answer");
    }
    
    const QuestionnaireAnswerTypeEnum = Common.QuestionnaireAnswerTypeEnum;
    return {
      QuestionnaireAnswerTypeEnum,
      entry,
    };
  }
})
